
import { getMenu } from '@/server/dashboard'
import store from '@/store/index'
import { _local } from '@/utils/storage'
import { menuMap } from '@/lib/menuFormat';
import { listToTree } from '@/utils/index';
import {
  deepClone,
} from '@/utils';
import {
  getAuthorityMenu,
} from '@/server/common';
export default {
  state: {
    menus: [], // 菜单数据
    collapse: false, // 是否收起
    routerList: [],
    updateRouterList: [],
    boardMenuLoading: false,
    curTab: '',
    webHookList: [],
    keepUpdateList: [],
    boardMenu: {
      platform: [],
      personal: []
    }
  },
  mutations: {
    'menu.setCollapse'(state, collapse) {
      state.collapse = collapse
    },
    'menu.setMenus'(state, data) {
      state.menus = data
    },
    'menu.setWebHookList'(state, data) {
      state.webHookList = data
    },
    setRouterList(state, data) {
      let list = [...store.state.user.authorityList]
      // 判断是否是已存在路由
      if (data.meta.keepAlive) {
        // 根据路由名判断是否是同一页
        if (state.routerList.every(el => el.name !== data.name)) {
          if (data.name === 'iframe-board' || data.name === 'data-board' || (data.query && data.query.actionId)) {
            data = { ...data, uniName: data.query.actionId && data.query.actionId.split('::')[0] }
          } else {
            // 获取多语言定义路由名，从权限里面拿，如果是不需要权限控制的页面，则从route.name中拿
            let item = list.filter(el => {
              let l = el.actionCode.split('::')
              return l[l.length - 1] === data.name
            })
            if (item.length) {
              data = { ...data, uniName: window.$t(item[0].actionCode.replace('shop-management', 'menu')) }
            } else if (window.$t(`menu::${data.name}`) !== data.name) {
              data = { ...data, uniName: window.$t(`menu::${data.name}`) }
            }
          }
          state.routerList.push(data)
          // 如果是看板带query，才需判断全部链接是否相等
        } else if (Object.keys(data.query).length && (data.name === 'iframe-board' || data.name === 'data-board')) {
          if (data.name === 'iframe-board' || data.name === 'data-board' || (data.query && data.query.actionId)) {
            data = { ...data, uniName: data.query.actionId.split('::')[0] }
          }
          if (state.routerList.every(el => el.fullPath !== data.fullPath)) {
            state.routerList.push(data)
          }
          // 店铺详情，商品详情算同一个页面
        } else if (Object.keys(data.params).length) {
          let item = list.filter(el => {
            let l = el.actionCode.split('::')
            return l[l.length - 1] === data.name
          })
          if (item.length) {
            data = { ...data, uniName: window.$t(item[0].actionCode.replace('shop-management', 'menu')) }
          } else if (window.$t(`menu::${data.name}`) !== data.name) {
            data = { ...data, uniName: window.$t(`menu::${data.name}`) }
          }
          let index = state.routerList.findIndex(el => el.name === data.name)
          state.routerList[index] = data
          // 当有query时，则更新链接
        } else if (data.name !== 'iframe-board' && data.name !== 'data-board') {
          let index = state.routerList.findIndex(el => el.name === data.name)
          state.routerList[index] = data
        }
      }
      state.curTab = data
    },
    removeRouter(state, data) {
      state.routerList = state.routerList.filter(el => el.fullPath !== data.fullPath)
    },
    clearRouterList(state, data) {
      state.routerList = []
    },
    setCurTab(state, data) {
      state.curTab = data
    },
    removekeepUpdateListItem(state, data) {
      state.keepUpdateList = state.keepUpdateList.filter(url => url !== data);
    },
    // 刷新缓存页列表
    setKeepUpdateList(state, data) {
      if (!state.keepUpdateList.includes(data)) {
        state.keepUpdateList.push(data);
      }
    },
    'menu.setBoardMenuLoading'(state, data) {
      state.boardMenuLoading = data
    },
    'menu.setBoardMenu'(state, data) {
      state.boardMenu = data
    },
    handleRouterList(state, data) {
      state.routerList = state.routerList.filter(el => el.query.folderID != data.folderID)
    }
  },
  actions: {
    /**
     * @description: 
     * @param {*} state
     * @param {*} data Array [$route, callback]
     * @return {*}
     * @name: 
     */
    updateRouter({ state }, data) {
      console.log(state.updateRouterList, data, '缓存路由目录')
      if (state.updateRouterList && state.updateRouterList.find(item => data[0] && item == data[0].path)) {
        data[1] && data[1](data[0].query)
        state.updateRouterList = state.updateRouterList.filter(item => item != data[0].path)
      }
    },

    /**
     * @description: 
     * @param {*} state
     * @param {*} data path
     * @return {*}
     * @name: 
     */
    setUpdateRouter({ state }, data) {

      state.updateRouterList.push(data)
    },
    async getBoardList(store, params = {}) {
      if (params.boardID) {
        // 刷新时关闭已修改或删除的看板tab
        store.commit('handleRouterList', params)
      }
      let platform = []
      let personal = []
      function format(data = [], boardType) {
        return data.map(el => {
          let children = el.children ? el.children.map(item => {
            let url = ''
            let actionCode = ''
            let name = `${item.folderName}::${item.boardID}`
            if (item.openType === 1) {
              url = `/iframe-board?folderID=${item.folderID}&actionId=${name}&openType=${item.openType}&boardType=${boardType}&iframe=${item.openData}`
              actionCode = `shop-management::iframe-board::${item.folderName}`
            } else if (item.openType === 2 && item.openData && item.openData.length) {
              url = `${item.openData}?folderID=${item.folderID}&boardID=${item.boardID}&actionId=${name}&openType=${item.openType}&boardType=${boardType}`
              actionCode = `shop-management::data-board::${item.folderName}`
            } else {
              url = `/data-board?boardID=${item.boardID}&folderID=${item.folderID}&actionId=${name}&openType=${item.openType}&boardType=${boardType}`
              actionCode = `shop-management::data-board::${item.folderName}`
            }
            return {
              actionCode: actionCode,
              url: url,
              name: name,
              actionId: item.boardID,
              actionName: item.folderName,
              actionType: 1,
              adminFlag: true,
              isCustomer: true,
              parentId: item.parentId,
              isShow: 1,
              sort: item.position,
              systemId: 3,
              openTarget: item.openTarget, // 1 页签 2 新页面
              openType: item.openType, // 1 url 2 平台看板 3 普通看板
              boardType: boardType // 1 公共看板 2 个人看板
            }
          }) : null
          return {
            actionCode: `shop-management::${el.folderName}`,
            actionId: el.folderID,
            actionName: el.folderName,
            icon: el.icon,
            isShow: el.isHide ? 0 : 1,
            name: `${el.folderName}::${el.folderID}`,
            //目录的父级则是400
            parentId: 400,
            actionType: 1,
            systemId: 3,
            sort: el.position,
            children: children
          }
        }).filter(el => el.children)
      }
      store.commit('menu.setBoardMenuLoading', true)
      try {
        const res1 = await getMenu(1)
        if (res1.status !== 200) {
          return
        }
        const data1 = res1.result
        if (data1.code === 0) {
          platform = format(data1.data, 1)
        }
        const res2 = await getMenu(2)
        if (res2.status !== 200) {
          return
        }
        const data2 = res2.result
        if (data2.code === 0) {
          personal = format(data2.data, 2)
        }
        if (params.update && _local.get('merchantId')) {
          _local.remove('AuthList')
          const [res] = await Promise.all([
            getAuthorityMenu(_local.get('merchantId'))
          ]);
          if (res.data.code === 0) {
            const menu = menuMap(res.data.data);
            _local.set('AuthList', res.data.data)
            store.commit('user.setAuthorityList', menu);
            store.commit('menu.setMenus', listToTree(deepClone(menu)));
          }
        }
        store.commit('menu.setBoardMenu', { platform: platform, personal: personal })
      } catch (e) {
        console.log(e)
      }
      store.commit('menu.setBoardMenuLoading', false)
    },
  }
}
